import React from 'react';
import saLogoAi from '../../assets/sa_logo_ai.svg';
import { useTheme } from './Theme';

interface SidebarBrandProps {
  collapsed: boolean;
  onClick: () => void;
}

const SidebarBrand: React.FC<SidebarBrandProps> = ({ collapsed, onClick }) => {
  const { theme } = useTheme();
  const isLight = theme === 'white';

  return (
    <button
      type="button"
      onClick={onClick}
      className={`group mx-auto flex w-full flex-col items-center justify-center rounded-xl transition-colors focus:outline-none ${collapsed ? 'gap-0 px-1 py-3' : 'gap-2 px-2 py-3.5'} ${isLight ? 'hover:bg-neutral-100/80' : 'hover:bg-neutral-800/50'}`}
      aria-label="Go to home"
      title="SelficAI"
    >
      <div className="relative">
        <div
          className={`absolute -inset-2.5 rounded-full bg-gradient-to-br from-blue-600/30 via-violet-500/25 to-cyan-400/30 blur-xl transition-opacity duration-300 ${isLight ? 'opacity-35 group-hover:opacity-65' : 'opacity-45 group-hover:opacity-80'}`}
          aria-hidden
        />
        <div
          className={`relative overflow-hidden rounded-full transition-transform duration-300 group-hover:scale-[1.03] ${collapsed ? 'h-10 w-10' : 'h-11 w-11'}`}
        >
          <img
            src={saLogoAi}
            alt="SelficAI"
            className="h-full w-full object-contain"
          />
        </div>
      </div>

      {!collapsed && (
        <div className="text-center leading-tight">
          <span className={`block text-sm font-bold tracking-tight ${isLight ? 'text-neutral-900' : 'text-white'}`}>
            Selfic
            <span className="bg-gradient-to-r from-blue-600 via-violet-500 to-cyan-500 bg-clip-text text-transparent">AI</span>
          </span>
          <span className={`mt-0.5 block text-[9px] font-medium uppercase tracking-[0.18em] ${isLight ? 'text-neutral-400' : 'text-neutral-500'}`}>
            AI Control Plane
          </span>
        </div>
      )}
    </button>
  );
};

export default SidebarBrand;
